import { Box } from '@/components/box/box';
import { styled } from '@/stitches.config';
import { MobileMetadata } from './mobile-metadata';
import { ImageCarousel } from './image-carousel';
import { WorkProject } from '@/lib/schemas/work-project';

type MobileSlideProps = {
  project: WorkProject;
  canAnimate: boolean;
};

export function MobileSlide({ project, canAnimate }: MobileSlideProps) {
  return (
    <Box>
      <ImageContainer>
        <ImageCarousel canAnimate={canAnimate} project={project} />
      </ImageContainer>
      <MobileMetadata
        title={project.target.title}
        subtitle={project.target.subtitle}
      />
    </Box>
  );
}

const ImageContainer = styled('div', {
  position: 'relative',
  width: '100%',
  aspectRatio: '1 / 1',
  '@supports not (aspect-ratio: 1 / 1)': {
    paddingBottom: '100%',
  },
});
